import React from "react";
import styles from "./education.module.scss";

const Education: React.FC = () => {
  return (
    <div className={styles.educationContainer}>
      <div className={styles.educationCard}>
        <div className={styles.header}>
          <div className={styles.schoolInfo}>
            <h3 className={styles.school}>Fachhochschule, Rosenheim</h3>
            <p className={styles.period}>October 2014 – June 2018</p>
          </div>
        </div>
        <div className={styles.programs}>
          <div className={styles.program}>
            <span className={styles.duration}>3 semester</span>
            <span className={styles.field}>"Wirtschaftsinformatik"</span>
          </div>
          <div className={styles.program}>
            <span className={styles.duration}>4 Semester</span>
            <span className={styles.field}>"Informatik"</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
